import { dayjs } from '@inflearn/i18n-tools';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import duration from 'dayjs/plugin/duration';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import isToday from 'dayjs/plugin/isToday';
import objectSupport from 'dayjs/plugin/objectSupport';
import relativeTime from 'dayjs/plugin/relativeTime';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import { i18n } from 'next-i18next';

import dayDiffFromNowPlugin from './dayDiffFromNowPlugin';
import toISOWeekOfMonth from './isoWeekOfMonthPlugin';

dayjs.extend(relativeTime);
dayjs.extend(duration);
dayjs.extend(isToday);
dayjs.extend(toISOWeekOfMonth);
dayjs.extend(dayDiffFromNowPlugin);
dayjs.extend(objectSupport);
dayjs.extend(isSameOrBefore);
dayjs.extend(customParseFormat);
dayjs.extend(timezone);
dayjs.extend(utc);

dayjs.locale(i18n?.language);

export const HOURS_TO_MINUTE = 60;
export const DAYS_TO_MINUTE = HOURS_TO_MINUTE * 24;
export const MINUTE_TO_MS = 60 * 1000;

export default dayjs;
export type { ConfigType } from 'dayjs';

/**
 * @description 2024-12-31T23:59:59 -> 2024. 12. 31.
 */
export function toYYYY_MM_DD(date: string) {
  return dayjs(date).format('L');
}

/**
 * @description 2024-12-31T23:59:59 -> 2024. 12. 31. 23:59
 */
export function toYYYY_MM_DD_HH_mm(date: string) {
  return dayjs(date).format('L HH:mm');
}

export function isBeforeToday(targetDate: string): boolean {
  return dayjs(targetDate).isBefore(dayjs(), 'day');
}

export function formatDate(date: string, format = 'L') {
  return dayjs(date).format(format);
}

export function setDateLocal(locale: string) {
  dayjs.locale(locale);
}
